module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.r) ? _c('gmap-info-window', {
    attrs: {
      "options": _vm.infoWindowOptions,
      "position": _vm.r.position
    },
    on: {
      "closeclick": function($event) {
        _vm.$bus.$emit('toggleDotInfo')
      }
    }
  }, [_c('div', {
    staticClass: "rp-iwin"
  }, [(!_vm.editing) ? [(!!_vm.r.name) ? _c('h3', [_vm._v(_vm._s(_vm.r.name))]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.compiledText)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "rp-iwin-note-editor"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Marker name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "text",
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "Marker description"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.r.position) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_vm._v(_vm._s(_vm._f("latlng")(_vm.r.position)))])]) : _vm._e(), _vm._v(" "), (_vm.r.position) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("What is here: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [(_vm.r.geocode.loading) ? _c('span', [_vm._v("Loading...")]) : (_vm.r.geocode.status == 2) ? _c('span', [_vm._v("No result")]) : (_vm.r.geocode.status == 1) ? _c('span', [_vm._v(_vm._s(_vm.r.geocode.data))]) : _c('span', [_vm._v("Geocode data should be here.")])])]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('p', {
    staticClass: "rp-iwin-actions"
  }, [_c('a', {
    staticClass: "rp-iwin-action btn btn-primary btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.edit()
      }
    }
  }, [_c('span', {
    staticClass: "icon-pencil"
  }), _vm._v(" Edit")]), _vm._v(" "), _c('a', {
    staticClass: "rp-iwin-action btn btn-default btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.remove()
      }
    }
  }, [_c('span', {
    staticClass: "icon-times"
  }), _vm._v(" Delete")])]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('p', {
    staticClass: "rp-iwin-actions"
  }, [_c('a', {
    staticClass: "rp-iwin-action btn btn-primary btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('span', {
    staticClass: "icon-checkmark"
  }), _vm._v(" Save")]), _vm._v(" "), _c('a', {
    staticClass: "rp-iwin-action btn btn-default btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('span', {
    staticClass: "icon-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "rp-iwin-action",
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Markdown",
      "target": "_blank"
    }
  }, [_vm._v("Markdown supported")])]) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2371ba29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/DotInfo.vue
// module id = 468
// module chunks = 0